import './File.scss'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon, Popconfirm, Progress, Spin } from 'antd'
import fileImg from './file.png'
import apiConfig from '../../../../config/api'
import { ReportService } from '../../../../services'
import { cancelProcessPromise } from '../../promises'
import i18n from '../../../../config/i18next'
import { PdfModal } from '../../../../layouts/Private/components'

const File = ({ file, currentUser }) => {
  const { t } = useTranslation()
  const [isDownloadingResults, setIsDownloadingResults] = useState(false)
  const [pdfSource, setPdfSource] = useState(null)
  const [isLoadingPdf, setIsLoadingPdf] = useState(false)

  const handleDownloadPDF = () => {
    setIsLoadingPdf(true)
    ReportService.pdfToObj('/pdfBatch', {id: file.id, lang: i18n.language}, null, 'batch.pdf').then((obj) => {
      setPdfSource(obj.data)
      setIsLoadingPdf(false)
    })
  }

  const handleDownloadZIP = async () => {
    await setIsDownloadingResults(true)
    let datePrefix = null
    if (file.fechaUpload) {
      if (typeof file.fechaUpload === 'number') {
        datePrefix = new Date(file.fechaUpload).toISOString().slice(0, 10)
      } else if (/^\d+$/.test(String(file.fechaUpload))) {
        datePrefix = new Date(Number(file.fechaUpload)).toISOString().slice(0, 10)
      } else {
        datePrefix = String(file.fechaUpload).split('T')[0]
      }
    }
    const zipName = datePrefix ? `${datePrefix}_resultados.zip` : 'resultados.zip'
    await ReportService.read('/zipFile', { id: file.id }, null, zipName)
    await setIsDownloadingResults(false)
  }

  const handleDownloadOriginal = async () => {
    await ReportService.read('/inputFile', { id: file.id }, null, file.fileName)
  }

  const renderStatusClassName = () => {
    const fileStatus = file.status
    const baseClassName = 'file'

    let statusClassName

    switch (fileStatus) {
      case 'NEW':
        statusClassName = 'queued'
        break

      case 'INPROCESS':
        statusClassName = 'in-process'
        break

      case 'PROCESSED':
        statusClassName = 'ready'
        break

      default:
        statusClassName = 'downloaded'
        break
    }

    return baseClassName + ' ' + statusClassName
  }

  const renderStatusString = () => {
    const fileStatus = file.status

    let statusString

    switch (fileStatus) {
      case 'NEW':
        statusString = t('messages.aml.queued')
        break

      case 'INPROCESS':
        statusString = t('messages.aml.inProcess')
        break

      case 'PROCESSED':
        statusString = ''
        break

      default:
        statusString = t('messages.aml.downloaded')
        break
    }

    return statusString
  }

  const renderStatusIcon = () => {
    const fileStatus = file.status

    let statusString

    switch (fileStatus) {
      case 'NEW':
        statusString = 'hourglass'
        break

      case 'INPROCESS':
        statusString = 'loading'
        break

      case 'PROCESSED':
        statusString = 'check'
        break

      default:
        statusString = 'check'
        break
    }

    return statusString
  }

  const renderStatusPercent = () => {
    const lines = file.lines
    const linesProcessed = file.linesProc

    return Math.round((linesProcessed * 100) / lines)
  }

  const handleCancelProcess = async (id) => {
    await cancelProcessPromise(id)
  }

  const closeHandlerPdfModal = () => {
    setPdfSource(null)
  }

  return (
    <div className={ renderStatusClassName() }>
      <div className="upper">
        <div className="status-bar">
          <div className="downloaded-sticker" />
          <span className="status-string">{ renderStatusString() }</span>
          <Icon type={ renderStatusIcon() } />
        </div>
        <div className="text-file-icon">
          <img src={ fileImg } alt="" />
        </div>
        <div className="progress-overlay">
          <Progress type="circle" percent={ renderStatusPercent() } strokeColor='#4d8842' strokeWidth="5" strokeLinecap="square" />
          <Popconfirm
            title="Desea cancelar el proceso ? ( Se eliminará el archivo definitivamente )"
            okText="Ok"
            cancelText={t('messages.aml.cancel', {ns: 'forms'})}
            onConfirm={ () => handleCancelProcess(file.id) }
          >
          <div className="stop-overlay"><Icon type="close" /></div>
          </Popconfirm>
        </div>
        <div className="buttons-overlay">
          <div>
            <Button type="primary" onClick={ handleDownloadPDF } disabled={isLoadingPdf}>
              <Icon type={isLoadingPdf ? 'loading' : 'cloud-download'} /> { t('messages.aml.certificatePdf') }
            </Button>
            <Button type="primary" onClick={ handleDownloadZIP }>
              <Icon type={ isDownloadingResults ? 'loading' : 'cloud-download' } /> { t('messages.aml.resultsZip') }
            </Button>
          </div>
        </div>
        <div className="black-overlay" />
      </div>
      <div className="lower" onClick={ handleDownloadOriginal }>
        <div className="file-name">
          <div className="file-name-inner" title={ file.fileName }>
            { file.fileName }
          </div>
        </div>
      </div>
      {pdfSource && 
        <PdfModal closeHandler={closeHandlerPdfModal} pdfSource={pdfSource} embeded={true} isObj ={true}/>
      }
    </div>
  )
}

export default File
